import React, { useContext } from 'react';
import i18next from 'i18next';
import SspProviderContext from '../../utils/SspProvider/context.ts';
import LanguageSwitch from './LanguageSwitch';
import './styles.scss';
import BackToSetup from '../BackToSetup';

function Footer(): React.ReactElement {
    const store = useContext(SspProviderContext);
    const languages = Object.keys(i18next.options.resources as object);

    return (
        <div className='footer'>
            <LanguageSwitch languages={languages} store={store} />
            <BackToSetup />
        </div>
    );
}

export default Footer;
